
import axios from '../../config/axiosConfig';
import { CREATE_WORKER, GET_WORKERS, WORKER_REQUEST, DELETE_WORKER, UPDATE_WORKER, WORKER_REQUEST_FAILURE, KARIGAR_WORKER_REQUEST, GET_KARIGAR_WORKERS, KARIGAR_WORKER_REQUEST_FAILURE } from '../types';

export const getWorkers = () => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: WORKER_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id };
            if (!auth?.company?.Common_Master) {
                params = { ...params, companyId: auth.company?.id }
            }
            return axios.get('/worker/getAll', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_WORKERS, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: WORKER_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: WORKER_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const createWorker = (worker) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: WORKER_REQUEST });
            return axios.post('/worker/add', worker,
                { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}
            ).then((response) => {
                if (response.data) {
                    dispatch({ type: CREATE_WORKER, payload: response.data });
                } else {
                    dispatch({ type: WORKER_REQUEST_FAILURE, error: 'Worker create failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: WORKER_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: WORKER_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updateWorker = (id, data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: WORKER_REQUEST });
            return axios.put('/worker/update', { id, data }, { params: { userId: auth.user?.id }}).then((response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_WORKER, payload: { id, data: response.data } });
                } else {
                    dispatch({ type: WORKER_REQUEST_FAILURE, error: 'Worker update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: WORKER_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: WORKER_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const deleteWorker = (id) => {
    return async (dispatch) => {
        try {
            dispatch({ type: WORKER_REQUEST });
            return axios.delete(`/worker/delete/${id}`).then((response) => {
                if (response.data) {
                    dispatch({ type: DELETE_WORKER, id: id });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: WORKER_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: WORKER_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const getKarigarWorkers = () => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: KARIGAR_WORKER_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id };
            if (!auth?.company?.Common_Master) {
                params = { ...params, companyId: auth.company?.id }
            }
            return axios.get('/worker/getAllKarigarWorkers', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_KARIGAR_WORKERS, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: KARIGAR_WORKER_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: KARIGAR_WORKER_REQUEST_FAILURE, error: error.message });
        }
    };
};